var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useMemo } from 'react';
import { secondaryDimensionListContext } from './context';
export var useSecondaryDimensionList = function () {
    var secondaryDimensionList = useContext(secondaryDimensionListContext);
    return secondaryDimensionList;
};
export var useSecondaryDimensionListElementByIndex = function (index) {
    var listData = useSecondaryDimensionList();
    var memoizedIndex = useMemo(function () { return listData[index]; }, [listData, index]);
    return memoizedIndex !== null && memoizedIndex !== void 0 ? memoizedIndex : {};
};
export function useSecondaryDimensionDataLength() {
    var data = useSecondaryDimensionList();
    return data.length;
}
export function useSecondaryDimensionDataIndexArray() {
    var length = useSecondaryDimensionDataLength();
    var listIndexArray = useMemo(function () { return __spreadArray([], __read(new Array(length)), false).map(function (_, k) { return k; }); }, [length]);
    return listIndexArray;
}
